import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

export const DeviceSerialNumber = observer(function DeviceSerialNumber(props: {
	deviceSerialNumber: string;
}) {
	const { t } = useTranslation("mybets");

	const { deviceSerialNumber } = props;

	return (
		<div className="bet__details__row table--bet__fiscalization__row">
			<div className="bet__details__col table--bet__fiscalization__data">
				{t("mybets:ITEM.ADDITIONAL_TSE_SERIAL_NUMBER")}:
			</div>
			<div className="bet__details__col table--bet__fiscalization__data">
				{deviceSerialNumber}
			</div>
		</div>
	);
});
